export enum WorkEntityType {
  Order = "Order",
  WorkOrder = "WorkOrder",
  Inspection = "Inspection",
}
